<template>
  <v-data-table
    :headers="headers"
    :items="items"
    dense
    class="elevation-1"
    :loading="loading"
  >
    <template #top>
      <v-toolbar flat>
        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-divider class="mx-4" inset vertical />

        <v-spacer />

        <slot name="actions" />
      </v-toolbar>
    </template>

    <template #item.StartDate="{ item }">
      <span>{{ formatDate(item.StartDate) }}</span>
    </template>

    <template #item.EndDate="{ item }">
      <span>{{ formatDate(item.EndDate) }}</span>
    </template>

    <template #item.GraduationDate="{ item }">
      <span>{{ formatDate(item.GraduationDate) }}</span>
    </template>

    <template #item.attachment="{ item }">
      <v-btn
        small
        outlined
        color="secondary"
        @click="$emit('download', item.Cert)"
      >
        <v-icon left> mdi-file</v-icon>

        Download
      </v-btn>
    </template>

    <template #item.actions="{ item }">
      <v-icon small class="mr-2" color="blue" @click="$emit('edit', item)">
        mdi-pencil
      </v-icon>

      <v-icon small color="red" @click="$emit('delete', item)">
        mdi-delete
      </v-icon>
    </template>
  </v-data-table>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";

export default {
  name: "CertificationTable",

  props: {
    title: {
      type: String,
      required: true,
    },

    headers: {
      type: Array,
      required: true,
    },

    items: {
      type: Array,
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  mixins: [DateMixin],
};
</script>
